export default "__VITE_ASSET__CkyBCC6b__"